module.exports = __webpack_public_path__ + "img/Instruction Learning Hub Box - no speaker-with padlock.aaf6b0d9.png";